import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { TResponse, TResponseWithQData } from "../../../types/common";
import { IServicePayload, ServiceItem } from "../../../types/api/service";
import { QData } from "../../../types/basic-type-list";

export async function saveService(
  data: IServicePayload
): Promise<AxiosResponse<TResponse<IServicePayload>>> {
  return axios.post<TResponse<IServicePayload>>(
    API_ENDPOINTS.SERVICE_SAVE,
    data
  );
}

export async function serviceDetail(
  slug: string
): Promise<AxiosResponse<TResponse<IServicePayload>>> {
  return axios.get<TResponse<IServicePayload>>(
    `${API_ENDPOINTS.SERVICE_DETAIL}/${slug}`
  );
}

export async function listService(
  qData: QData
): Promise<AxiosResponse<TResponseWithQData<ServiceItem[]>>> {
  return axios.get<TResponseWithQData<ServiceItem[]>>(
    API_ENDPOINTS.SERVICE_LIST,
    {
      params: qData,
    }
  );
}


export async function deleteService(
  payload: { id: string | string[] }
): Promise<AxiosResponse<TResponse<null>>> {
  return axios.post<TResponse<null>>(API_ENDPOINTS.SERVICE_DELETE, payload);
}
